import { GetSidebarItemFn } from "@/components/layout/Sidebar/sidebar.types";
import { dashboardItem, engineeringMenu } from "@/features/views/sidebar-items/sidebar-items";

const profitabilityItem: GetSidebarItemFn = () => ({
    _type: "link",
    route: "profitability",
    title: "Profitability",
    icon: "lely-icon-income",
});

const strategicOverviewItem: GetSidebarItemFn = () => ({
    _type: "link",
    route: "strategicOverview",
    title: "Strategic Overview",
    icon: "lely-icon-graph",
});

const serviceAreaSupportItem: GetSidebarItemFn = () => ({
    _type: "link",
    route: "serviceAreaSupport",
    title: "Service Area Support",
    icon: "lely-icon-location",
});

const attentionCustomersItem: GetSidebarItemFn = () => ({
    _type: "link",
    route: "attentionCustomers",
    title: "Attention Customers",
    icon: "lely-icon-human",
});

const devicesItem: GetSidebarItemFn = () => ({
    _type: "link",
    route: "devices",
    title: "Devices",
    icon: "lely-icon-robot",
});

const agreementsItem: GetSidebarItemFn = () => ({
    _type: "link",
    route: "agreements",
    title: "Agreements",
    icon: "lely-icon-robot",
});

export const serviceManagerSidebarItems: GetSidebarItemFn[] = [
    dashboardItem,
    profitabilityItem,
    engineeringMenu,
    strategicOverviewItem,
    serviceAreaSupportItem,
    attentionCustomersItem,
    devicesItem,
    agreementsItem,
];
